var _path, _path2, _circle, _circle2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1851 17.8888H14.6296C13.1568 17.8888 11.9629 19.0827 11.9629 20.5555V27.5751L11.9629 32.111C11.9629 33.5838 13.1568 34.7777 14.6296 34.7777H23.074H31.5184C32.9912 34.7777 34.1851 33.5838 34.1851 32.111V26.7777",
    stroke: "currentColor",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9629 22.7778H19.074C21.0377 22.7778 22.6296 24.3697 22.6296 26.3334V26.3334C22.6296 28.2971 21.0377 29.8889 19.074 29.8889H11.9629V22.7778Z",
    stroke: "currentColor",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6296,
    cy: 26.3333,
    r: 0.888889,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.888889
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1853,
    cy: 18.7778,
    r: 5.33333,
    stroke: "currentColor",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1852 17L34.1852 20.5556",
    stroke: "currentColor",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9629 18.7778L32.4073 18.7778",
    stroke: "currentColor",
    strokeWidth: 2.06933,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding);
export default __webpack_public_path__ + "static/media/Funding.63cd660911f194f2b2c6e2555a71c92c.svg";
export { ForwardRef as ReactComponent };